// ─── OrganigramaWorkflowBar — wrapper ultra-fino del shared (ADR-025 ext 0661) ──
// Tras 0661, este wrapper solo inyecta el adapter ORGANIGRAMA al shared
// `<ArtefactoWorkflowBar>` que generaliza la lógica de versiones + etapa + historial
// + workflow bar para los 3 artefactos (organigrama, doc, flujograma).
//
// Endpoints ORGANIGRAMA (sin cambios backend):
//   GET  /api/v1/organigrama/versiones?pageSize=50
//   POST /api/v1/organigrama/versiones                  (crear borrador)
//   POST /api/v1/organigrama/versiones/:id/transitar    (motor unificado ADR-025)
//   GET  /api/v1/workflow/etapa-actual/ORGANIGRAMA/:id

import {
  ArtefactoWorkflowBar,
  type ArtefactoAdapter,
} from '../../../shared/components/ArtefactoWorkflowBar';
import type { EstadoWorkflow } from '../../../shared/components/WorkflowBar';
import { useAuth } from '../../../../context/AuthContext';

const ORGANIGRAMA_ADAPTER: ArtefactoAdapter = {
  artefactoTipo: 'ORGANIGRAMA',
  endpointListVersiones: '/organigrama/versiones?pageSize=50',
  buildEndpointTransitar: (id) => `/organigrama/versiones/${id}/transitar`,
  buildEndpointEtapaActual: (id) => `/workflow/etapa-actual/ORGANIGRAMA/${id}`,
  endpointCrearBorrador: '/organigrama/versiones',
  buildCrearBorradorPayload: (descripcion) => ({ descripcionCambios: descripcion }),
  tieneVersionado: true,
};

interface OrganigramaWorkflowBarProps {
  /** Si false, oculta el componente (no editable). Default true. */
  enabled?: boolean;
  /** 0635 T-3: callback con el estado de la versión activa (permite al padre
   *  condicionar UI, ej. ocultar "Editar organigrama" si no es BORRADOR). */
  onVersionStateChange?: (state: EstadoWorkflow | null) => void;
  /** 0635 T-1: callback al click en una versión del popover historial (permite
   *  al padre cargar el snapshot inmutable y mostrarlo en el visor). */
  onSelectVersion?: (versionId: string, numeroEdicion: number) => void;
}

export function OrganigramaWorkflowBar({
  enabled = true,
  onVersionStateChange,
  onSelectVersion,
}: OrganigramaWorkflowBarProps) {
  // 0670 — visibilidad por rol: si NO es admin (SUPERADMIN/OWNER/ADMIN del
  // tenant), forzamos soloVigente=true. El componente entonces oculta
  // WorkflowBar (acciones), botón "Crear borrador", y muestra solo la versión
  // PUBLICADO vigente con pill "Solo lectura". Esto cubre TENANT_AUDITOR +
  // MEMBER. La cascada fina por participación en WorkflowConfig queda como
  // backlog [0670][BACKEND-RBAC-WORKFLOW].
  const { isAdmin } = useAuth();
  const soloVigente = !isAdmin;

  return (
    <ArtefactoWorkflowBar
      adapter={ORGANIGRAMA_ADAPTER}
      enabled={enabled}
      onVersionStateChange={onVersionStateChange}
      onSelectVersion={onSelectVersion}
      compact
      soloVigente={soloVigente}
    />
  );
}
